import styled from 'styled-components';
import * as Common from '../../Styles';

const Theme = Common.Theme;

export const TitleColumn = styled(Common.FlexColumn)`
	flex-grow: 1;
	flex: auto;
`;

export const FiltersColumn = styled(Common.FlexColumn)`
	flex-shrink: 0;
	width: auto;
	padding-top: 4px;
`;

export const DetailsColumn = styled(Common.FlexColumn)`
	align-self: flex-start;
	line-height: 20px;
`;

export const ItemName = styled(Common.FlexRow)``;

export const ItemID = styled(Common.FlexRow)`
	font-size: 12px;
	font-weight: normal;
	color: ${Theme.darkGrey};
`;
